"use client"

import { useKeyboardScroll } from "@/lib/hooks/use-keyboard-scroll"

export function KeyboardScrollProvider() {
  useKeyboardScroll()
  return null
}
